module.exports = __webpack_public_path__ + "static/media/buy-red-medium.ec26578a.png";